import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import "crypto-js";
import moment from "moment";
import { localCalendarAction } from "./calendarRequest";
import {
  getStaffAvailabilityAction,
  normalizeStaffAvailabilityValues,
} from "./staffAvailabilityEndpoint";
import { appendStaffFormValues, staffUpdateAction } from "./staffPayload";

const API_URL = config.API_URL;

// Paginator URLs returned by Laravel may be absolute and point at another host.
// Keep only the value so the request is always rebuilt against the configured
// Flask API rather than following an untrusted link.
const calendarLegacyQuery = (url, name) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return new URL(url, "https://calendar-list.invalid").searchParams.get(name);
  } catch (_error) {
    return null;
  }
};

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = appendStaffFormValues(new FormData(), values);
  const action = "afterlogin/staff/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = appendStaffFormValues(new FormData(), values);
  const action = staffUpdateAction(values);
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const calendarresourceandstaff = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  // const result = values && values.result ? values.result : "";
  // const staff_id = values && values.staff_id ? values.staff_id : "";
  // const resource_id = values && values.resource_id ? values.resource_id : "";
  // const resource_item_id = values && values.resource_item_id ? values.resource_item_id : "";
  // const type = values && values.type ? values.type : "";
  // const pagetype = values && values.pagetype ? values.pagetype : "";
  // const getRow = values && values.getRow ? values.getRow : "";
  // const calendarTab = values && values.calendarTab ? values.calendarTab : "";

  // let resourcedata;
  // resourcedata = {
  //   id: "",
  //   pagetype: pagetype,
  //   getRow: getRow,
  //   page_name: values && values.page_name ? values.page_name : "",
  //   singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
  //   auth_key: auth_key,
  //   action: action,
  //   pagination: false,
  //   staff_id: staff_id,
  //   resource_id: resource_id,
  //   resource_item_id: resource_item_id,
  //   calendarTab: calendarTab,
  //   type: type,
  //   result: result,
  // };
  // const data = resourcedata;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = localCalendarAction("afterlogin/staff/calendarstaffresource", values);
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const result = values && values.result ? values.result : "";
  const dropdown = values && values.dropdown ? values.dropdown : "";
  const service_id = values && values.service_id ? values.service_id : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  const getRow = values && values.getRow ? values.getRow : "";
  const availebleTimeObj = values && values.availebleTimeObj ? values.availebleTimeObj : "";
  const formName = values && values.formName ? values.formName : "";
  const suppliedQuery = values && typeof values.q === "string" ? values.q : null;
  const legacyQuery =
    suppliedQuery === null
      ? calendarLegacyQuery(values && values.next_page_url, "q") || ""
      : null;
  const searchQuery = (suppliedQuery === null ? legacyQuery : suppliedQuery).trim();
  const encodedQuery = searchQuery ? `q=${encodeQueryValue(searchQuery)}` : "";

  let sortstring = "";
  if (sort) {
    let sortArray = [];
    let sortSubArray = [];
    Object.keys(sort).map(function (key, index) {
      if (Object.keys(sort[key]).length > 0) {
        Object.keys(sort[key]).map(function (subkey, subindex) {
          sortSubArray[subindex] = `sort[${key}.${subkey}]=${sort[key][subkey]}`;
        });
      }
      if (key != "supplier") {
        sortArray[index] = `sort[${key}]=${sort[key]}`;
      }
    });
    if (sortSubArray.length > 0) {
      let jsubsort = sortSubArray.join("&");
      sortstring = jsubsort;
    }
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
    if (values.maxstaffAlert) {
      pagination = false;
    }
    if (values.staff_paginate) {
      pagination = true;
    }
  }
  const query = [sortstring, encodedQuery].filter(Boolean).join("&");
  const action = localCalendarAction("afterlogin/staff/view", values, query);
  let staffdata;
  if (dropdown) {
    staffdata = {
      auth_key: auth_key,
      action: action,
      pagination: false, //true or false
      id: "",
      result: result, //business_name,owner_name
      pagetype: pagetype,
      getRow: getRow,
      dropdown: dropdown,
      q: searchQuery,
      option: values && values.option ? values.option : "",
      page_name: values && values.page_name ? values.page_name : "",
      singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
      availebleTimeObj,
      formName
    };
  } else {
    staffdata = {
      auth_key: auth_key,
      action: action,
      pagination: pagination, //true or false
      id: values && values.id ? values.id : "",
      result: result, //business_name,owner_name
      option: values && values.option ? values.option : "",
      dropdown: dropdown,
      q: searchQuery,
      service_id: service_id,
      pagetype: pagetype,
      page_name: values && values.page_name ? values.page_name : "",
      singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
      availebleTimeObj,
      formName
    };
  }
  const data = staffdata;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/staff/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader(), ...(values.archive === true ? { deleteConfirmation: false } : {}) });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let q = values && values.q ? values.q : "";
  const encodedQ = encodeQueryValue(q);
  const action = page ? `afterlogin/staff/view?page=${page}&q=${encodedQ}` : `afterlogin/staff/view?q=${encodedQ}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&q=${encodedQ}` : API_URL + action, data, { headers: authHeader() });
};

const addonservices = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let staff_id = values && values.staff_id ? values.staff_id : "";
  const action = page ? `afterlogin/staff/addonservices?page=${page}&staff_id=${staff_id}` : `afterlogin/staff/addonservices?staff_id=${staff_id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const staffavailabletime = (values, thunkAPI = {}) => {
  values = normalizeStaffAvailabilityValues(values);
  const auth = store.getState()?.auth || { user: {} };
  void (auth.user.auth_key);
  // const formData = new FormData();
  // for (let value in values) {
  //   if (["dateof"].includes(value) && values[value]) {
  //     formData.append(value, moment(values[value], "dddd, DD MMMM YYYY").format("YYYY-MM-DD"));
  //   } else {
  //     formData.append(value, values[value]);
  //   }
  // }
  // const action = "afterlogin/staff/availabletime";
  // formData.append("auth_key", auth_key);
  // formData.append("action", action);
  // return axios.post(API_URL + action, formData, { headers: authHeader() });
  const listview = values && values.listview ? values.listview : "";
  const appointment_id = values && values.id ? values.id : "";
  const busytime_id = "";
  const service_id = values && values.service_id ? values.service_id : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const prev_start_datetime = values && values.prev_start_datetime ? values.prev_start_datetime : "";
  const dateof = values && values.dateof ? values.dateof : "";

  const uid = values && values.uid ? values.uid : "1";
  const apicall = values && values.apicall ? values.apicall : "staff";
  const salon_id = auth && auth.user ? auth.user.salon_id : "";
  const duration = values && values.duration ? values.duration : "";
  const padding_time = values && values.padding_time ? values.padding_time : "";
  const durationWithPadding = values && values.durationWithPadding ? values.durationWithPadding : "";
  const parentAppointmentEndTime = values && values.parentAppointmentEndTime ? values.parentAppointmentEndTime : "";
  const roster_time = values && values.roster_time ? values.roster_time : "";
  const formtype = values && values.formtype ? values.formtype : "";
  const resource_item_id = values && values.resource_item_id ? values.resource_item_id : "";
  const start_datetime = values && values.start_datetime ? values.start_datetime : (dateof ? dateof : "");
  const isDurationCheck = values && values.isDurationCheck ? values.isDurationCheck : "";
  const totalDurationWithPadding = values && values.totalDurationWithPadding ? values.totalDurationWithPadding : "";
  const formName = values && values.formName ? values.formName : "";
  // const action = `widget/staff/availabletime`;
  const action = `afterlogin/appointment/nextresourceitemtime`;
  const data = {
    action: action,
    remove_addon : values?.remove_addon || [],
    remove_addanother : values?.remove_addanother || [],
    service_id: service_id,
    staff_id: staff_id,
    dateof: dateof,
    uid: uid,
    apicall: apicall,
    salon_id: salon_id,
    duration: duration,
    padding_time: padding_time,
    durationWithPadding: durationWithPadding,
    totalDurationWithPadding: totalDurationWithPadding,
    parentAppointmentEndTime: parentAppointmentEndTime,
    listview: listview,
    roster_time: roster_time,
    appointment_id: listview == "Appointment" ? appointment_id : "",
    busytime_id: listview == "BusyTime" ? busytime_id : "",
    formtype: formtype,
    isDurationCheck: isDurationCheck,
    list_all_slots: values && values.list_all_slots === true,
    resource_item_id: resource_item_id,
    start_datetime,
    prev_start_datetime,
    formName
  };
  return axios.post(API_URL + action, data, {
    headers: authHeader(),
    signal: thunkAPI.signal,
  });
};

const staffbusytime = (values, thunkAPI = {}) => {
  values = normalizeStaffAvailabilityValues(values);
  const auth = store.getState()?.auth || { user: {} };
  void (auth.user.auth_key);
  const listview = values && values.listview ? values.listview : "";
  const busytime_id = values && values.id ? values.id : "";
  const appointment_id = "";
  const service_id = values && values.service_id ? values.service_id : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const prev_start_datetime = values && values.prev_start_datetime ? values.prev_start_datetime : "";
  const dateof = values && values.dateof ? values.dateof : "";
  const uid = values && values.uid ? values.uid : "1";
  const apicall = values && values.apicall ? values.apicall : "staff";
  const salon_id = auth && auth.user ? auth.user.salon_id : "";
  const duration = values && values.duration ? values.duration : "";
  const padding_time = values && values.padding_time ? values.padding_time : "";
  const durationWithPadding = values && values.durationWithPadding ? values.durationWithPadding : "";
  const parentAppointmentEndTime = values && values.parentAppointmentEndTime ? values.parentAppointmentEndTime : "";
  const roster_time = values && values.roster_time ? values.roster_time : "";
  const formtype = values && values.formtype ? values.formtype : "";
  const resource_item_id = values && values.resource_item_id ? values.resource_item_id : "";
  const start_datetime = values && values.start_datetime ? values.start_datetime : (dateof ? dateof : "");
  const isDurationCheck = values && values.isDurationCheck ? values.isDurationCheck : "";
  const formName = values && values.formName ? values.formName : "";
  const action = getStaffAvailabilityAction();
  const data = {
    action: action,
    service_id: service_id,
    staff_id: staff_id,
    dateof: dateof,
    uid: uid,
    apicall: apicall,
    salon_id: salon_id,
    duration: duration,
    padding_time: padding_time,
    durationWithPadding: durationWithPadding,
    parentAppointmentEndTime: parentAppointmentEndTime,
    listview: listview,
    roster_time: roster_time,
    appointment_id: listview == "Appointment" ? appointment_id : "",
    busytime_id: listview == "BusyTime" ? busytime_id : "",
    availableBusyTime: values.availableBusyTime,
    formtype: formtype,
    isDurationCheck: isDurationCheck,
    resource_item_id: resource_item_id,
    start_datetime,
    prev_start_datetime,
    formName
  };
  return axios.post(API_URL + action, data, {
    headers: authHeader(),
    signal: thunkAPI.signal,
  });
};

// FullCalendar ends are exclusive; these support endpoints use inclusive dates.
const calendarSupportEnd = (values) => {
  if (!values?.end_date) return "";
  const end = moment.parseZone(values.end_date);
  if (["day", "week"].includes(values.type) && end.isAfter(moment.parseZone(values.start_date), "day")) end.subtract(1, "day");
  return end.format("YYYY-MM-DD HH:mm:ss");
};

const staffworkinghours = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/staff/staffworkinghours`;
  //Working hour Calender view parameter
  const start_date = values && values.start_date ? moment.parseZone(values.start_date).format("YYYY-MM-DD HH:mm:ss") : "";
  const end_date = calendarSupportEnd(values);
  const timezone = values && values.timezone ? values.timezone : "";
  const type = values && values.type ? values.type : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const showdate = values && values.showdate ? moment(values.showdate).format("YYYY-MM-DD HH:mm:ss") : "";
  const showstartdate = values && values.showstartdate ? moment(values.showstartdate).format("YYYY-MM-DD HH:mm:ss") : "";
  const showenddate = values && values.showenddate ? moment(values.showenddate).format("YYYY-MM-DD HH:mm:ss") : "";

  const data = {
    auth_key: auth_key,
    action: action,
    id: values && values.id ? values.id : "",
    start_date: start_date,
    end_date: end_date,
    timezone: timezone,
    type: type,
    staff_id: staff_id,
    showdate: showdate,
    showstartdate: showstartdate,
    showenddate: showenddate,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : ""
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const staffawayapi = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/staff/staffaway`;
  //Working hour Calender view parameter
  const start_date = values && values.start_date ? moment.parseZone(values.start_date).format("YYYY-MM-DD HH:mm:ss") : "";
  const end_date = calendarSupportEnd(values);
  const timezone = values && values.timezone ? values.timezone : "";
  const type = values && values.type ? values.type : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const formName = values && values.formName ? values.formName : "";
  const showdate = values && values.showdate ? moment(values.showdate).format("YYYY-MM-DD HH:mm:ss") : "";
  const showstartdate = values && values.showstartdate ? moment(values.showstartdate).format("YYYY-MM-DD HH:mm:ss") : "";
  const showenddate = values && values.showenddate ? moment(values.showenddate).format("YYYY-MM-DD HH:mm:ss") : "";

  const data = {
    auth_key: auth_key,
    action: action,
    id: values && values.id ? values.id : "",
    start_date: start_date,
    end_date: end_date,
    timezone: timezone,
    type: type,
    staff_id: staff_id,
    showdate: showdate,
    showstartdate: showstartdate,
    showenddate: showenddate,
    formName: formName,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : ""
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const addonstaffoptions = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let service_id = values && values.service_id ? values.service_id : "";
  let add_on_service_id = values && values.add_on_service_id ? values.add_on_service_id : "";
  let staff_id = values && values.staff_id ? values.staff_id : "";
  let isNotId = values && values.isNotId ? values.isNotId : "";
  const action = page ? `afterlogin/services/addonstaff?page=${page}&isNotId=${isNotId}` : `afterlogin/services/addonstaff?isNotId=${isNotId}`;
  const data = {
    auth_key: auth_key,
    action: action,
    service_id: service_id,
    add_on_service_id: add_on_service_id,
    staff_id: staff_id,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const staffaccesscreate = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["working_hours"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/staff/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const staffaccesslistview = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/useraccess/view?page=${page}` : `afterlogin/useraccess/view`;

  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    salon_id: values && values.client_id ? values.client_id : "",
    result: values && values.result ? values.result : "", //business_name,owner_name
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const rosterstaff = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/staff/rosterstaff`;
  //Working hour Calender view parameter
  const start_date = values && values.start_date ? moment.parseZone(values.start_date).format("YYYY-MM-DD HH:mm:ss") : "";
  const end_date = calendarSupportEnd(values);
  const timezone = values && values.timezone ? values.timezone : "";
  const type = values && values.type ? values.type : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const showdate = values && values.showdate ? moment(values.showdate).format("YYYY-MM-DD HH:mm:ss") : "";
  const showstartdate = values && values.showstartdate ? moment(values.showstartdate).format("YYYY-MM-DD HH:mm:ss") : "";
  const showenddate = values && values.showenddate ? moment(values.showenddate).format("YYYY-MM-DD HH:mm:ss") : "";

  const data = {
    auth_key: auth_key,
    action: action,
    id: values && values.id ? values.id : "",
    start_date: start_date,
    end_date: end_date,
    timezone: timezone,
    type: type,
    staff_id: staff_id,
    showdate: showdate,
    showstartdate: showstartdate,
    showenddate: showenddate,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : ""
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const staffcounts = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/staff/staffcount";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const updateBreak = (values) => axios.post(API_URL + "afterlogin/staff/break/update", values, { headers: authHeader() });

const staffApiController = {
  updateBreak,
  create,
  update,
  view,
  deleted,
  suggetionlist,
  addonservices,
  staffavailabletime,
  staffworkinghours,
  staffawayapi,
  addonstaffoptions,
  staffaccesscreate,
  staffaccesslistview,
  rosterstaff,
  calendarresourceandstaff,
  staffbusytime,
  staffcounts
};
export default staffApiController;
